<div class="estimate-main-list-page">

    <div class="wrap">
        
    <!-- Top -->
        <div class="top">

            <!-- ✅ NAVBAR ALWAYS SHOWS -->
            <nav class="navbar navbar-expand-lg custom-navbar"
                [class.scrolled]="isNavbarWhite">

                <div class="container flex-lg-row flex-nowrap align-items-center nav-bar" style="    margin: 0;   width: 100%;    max-width: 100%;     padding: 15px 20px;">
                <div class="navbar-collapse-wrapper d-flex flex-row flex-nowrap w-100 justify-content-between align-items-center padding">

                    <div class="logo-wth-txt d-flex align-items-center gap-3 nav-logo clickable"
                        (click)="goToGarageDetails()">
                    <span class="nav-link">Home</span>
                    </div>

                    <button class="navbar-toggler d-lg-none mat-hamburger-btn"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target=".offcanvas-nav">
                    <mat-icon>menu</mat-icon>
                    </button>
                </div>

                <!-- menu -->
                <div #offcanvasMenu class="navbar-collapse offcanvas offcanvas-nav offcanvas-start">
                    <div class="offcanvas-header d-lg-none">
                       <h3 class="text-white fs-30 mb-0">  {{ garageShortName }}</h3>
                        <button
                        type="button"
                        class="btn-close btn-close-white"
                        data-bs-dismiss="offcanvas"
                        ></button>
                    </div>
                    <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
                    <ul class="navbar-nav align-items-center-abt">
                        <!-- <li class="nav-item"><a class="nav-link" (click)="scrollTo('service-description')">Service Details</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="scrollTo('whats-included')">What’s Included</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="scrollTo('faqs')">FAQs</a></li> -->
                        <li class="nav-item book" style="display: flex; align-items: center;">
                        <button class="btn btn-lg btn-outline-white rounded-pill rqstbtn"
                                style="background: #144579; color: white !important;"
                                (click)="openRequestModal()">
                            Book an Appointment
                        </button>

                        </li>
                    </ul>
                    </div>
                </div>
                </div>
            </nav>
            <div  class="top-left-main" *ngIf="isCarSelected">
            <!-- ✅ CAR DETAILS ONLY IF SELECTED -->
                <div class="top-left" *ngIf="isCarSelected">
                    <div class="plate">{{ vehicleData?.registrationNumber }}</div>
                    <div class="subtitle">
                    {{ vehicleData?.make }} {{ vehicleData?.model }} ·
                    {{ vehicleData?.year }} · {{ vehicleData?.fuel }}
                    </div>

                    <div class="badges">
                    <!-- <span class="badge blue">🏆 Autoverse Assured</span>
                    <span class="badge green">✓ Genuine Parts</span>
                    <span class="badge yellow">💰 Transparent Pricing</span>
                    <span class="badge purple">🛡️ Warranty Support</span> -->
                    <span class="tag warn">⏱ 90–120 mins</span>
                    </div>
                </div>
                <div class="btn-change" *ngIf="isCarSelected" (click)="goToRegistrationDecode()">Change Car</div>
            </div>
        </div>


        <div class="main-class">
            <!-- Sidebar -->
            <aside class="side">
                <h4>Service Categories</h4>
                <ul class="cat">
                    <li *ngFor="let cat of categories" 
                        [class.active]="selectedCategoryId === cat.id" 
                        (click)="selectCategory(cat.id)">
                    <div class="icon-and-text">
                        <span>{{ cat.icon || '🔧' }}</span>
                        <span class="small-text">{{ cat.name }}</span>
                    </div>
                    <span class="count">{{ cat.subCategoryCount || 0 }}</span>
                    </li>
                </ul>
            </aside>


            <!-- Main -->
            <main class="main">
                <!-- =====================sub-categories============== -->
                <!-- <div class="seg" role="tablist">
                    <button *ngFor="let sub of filteredSubCategories" 
                        [class.active]="sub.id === selectedSubCategoryId" 
                        (click)="selectSubCategory(sub.id)">
                        {{ sub.name }}
                    </button>
                </div> -->
                <!-- Show subcategory tags ONLY if it has childSubCategory -->
                <div class="seg"
                    role="tablist"
                    *ngIf="hasChildSubCategoryInCategory">

                    <button *ngFor="let sub of childOnlySubCategories"
                        [class.active]="sub.id === selectedSubCategoryId"
                        (click)="selectSubCategory(sub.id)">
                        {{ sub.name }}
                    </button>

                </div>


            <!-- Search box -->
            <div class="search">
                <span class="material-icons">search</span>
                <input [(ngModel)]="searchQuery" placeholder="Search services in this category..." style="color: black !important; background: none;" />
                <!-- <span *ngIf="searchQuery" class="material-icons clear-icon" (click)="searchQuery = ''">close</span> -->
                <span *ngIf="searchQuery" class="material-icons clear-icon" (click)="clearSearch()">close</span>
            </div>

            <!-- <div class="info">
                <span class="material-icons" style="color: black;">info</span>
                <div>
                <strong>OEM parts by default for guaranteed fit.</strong>
                <div style="margin-top:4px">
                    Switch to OES for the same performance at a smarter price —
                    <span class="chip">save up to ₹450</span> without compromising quality. Savings are shown clearly on every part.
                </div>
                </div>
            </div> -->
            <div class="Price-info">
                <div>
                <strong> 💡 Price shown includes labour only. Parts cost will be shown on the details page.</strong>
                </div>
            </div>
            
            <!-- Services List -->
            <section class="cards">
                <article class="card" *ngFor="let service of filteredServices"  style="cursor: pointer;">
                <!-- <div class="card-head" (click)="goToEstimateDetails(service)">{{ service.category }}</div> -->
                <!-- <img src="../../../assets/img/estimate-image.jpg" (click)="goToEstimateDetails(service)"> -->
                <img src="../../../assets/img/estimate-image.jpg" (click)="handleServiceClick(service)">
                <div class="card-body">
                    <div class="svc-title">{{ service.title }}</div>
                    <!-- <div class="price">From {{ service.price }}</div> -->
                    <div class="price">From {{ service.labourTotal }}</div>
                    <div class="incl">
                    <!-- <div class="svc-sub">Incl. parts + labour</div> -->
                     <div style="display: inline;">
                        <span class="tag warn">⏱ 90–120 mins</span>
                        <div class="service-meta-wrapper" *ngIf="getServiceMetaInfo(service) as meta">

                            <div class="service-meta-tag">
                                <mat-icon>schedule</mat-icon>
                                {{ meta.time }}
                            </div>

                            <div class="service-meta-tag">
                                <mat-icon>autorenew</mat-icon>
                                {{ meta.interval }}
                            </div>

                            </div>

                    </div>

                    </div>
                    <div class="row-tags">
                        <!-- <span class="tag" *ngFor="let tag of service.tags">{{ tag }}</span> -->
                        <!-- hardcoded tags -->
                        <!-- <span class="ganuine-tag">Genuine Parts</span>
                        <span class="assured-tag">Autoverse Assured</span> -->
                    </div>
                    <!-- <div class="btn-group">
                        <button class="btn ghost">Price Breakdown</button>
                        <button 
                            class="btn" 
                            [ngClass]="{'primary': !isInEstimate(service), 'added': isInEstimate(service)}" 
                            (click)="addToEstimate(service)"
                            [disabled]="isInEstimate(service)">
                            {{ isInEstimate(service) ? 'Added ✓' : 'Add to Estimate' }}
                        </button>
                    </div> -->

                    <!-- <div class="btn-group">
                        <button class="btn-vew-detals" (click)="goToEstimateDetails(service)" >View Details </button>
                    </div> -->
                    <div class="btn-group">
                        <button  *ngIf="!isCarSelected" class="btn-vew-detals" (click)="goToRegistrationDecode()" id="select-car" >Select Car</button>
                    </div>
                    <div class="btn-group">
                        <button *ngIf="isCarSelected" class="btn primary"  (click)="openBookingModal(service)" data-bs-toggle="modal" data-bs-target="#requestCallBackModal" style="font-size: 16px;">
                            <mat-icon>bookmark_border</mat-icon>
                            Book a Service
                        </button>
                    </div>
                    
                </div>
                </article>
            </section>
            <section *ngIf="noServicesFound" class="no-service">
                <div style="text-align: center; margin-top: 20px;">
                    <p style="font-size: 16px; color: #555;">No services found for this category and subcategory.</p>
                </div>
            </section>

            </main>


            <!-- Estimate Sidebar -->
            <!-- <aside class="est">
                <div class="est-head">
                    <h4 id="est-heading">{{ estimateList.length ? 'My Service Estimate' : 'Your Service Estimate' }}</h4>
                    <button type="button" class="clear" *ngIf="estimateList.length" (click)="clearEstimate()">Clear all</button>

                </div>

                <div id="empty-state" *ngIf="estimateList.length === 0" class="empty-estimate">
                    <div style="font-size: 40px; text-align:center;">🛠️</div>
                    <p style="text-align:center; font-weight: 500;">No services selected</p>
                    <p style="text-align:center; font-size: 13px; color:#777;">
                    Add services to build your estimate
                    </p>
                </div>

                <div id="estimate-list" *ngIf="estimateList.length > 0">
                    <div class="svc-card" *ngFor="let item of estimateList">
                    <div class="svc-title">
                        <div class="left">
                        <div class="name">{{ item.title }}</div>
                        <div class="price">{{ item.price }}</div>
                        </div>
                        <div class="right">
                        <button class="remove material-icons" (click)="removeFromEstimate(item)">close</button>
                        <div class="qty-row">
                            <button class="qty-btn" (click)="toggleQuantity(item, -1)">-</button>
                            <span>{{ item.quantity }}</span>
                            <button class="qty-btn" (click)="toggleQuantity(item, 1)">+</button>
                        </div>
                        </div>
                    </div>
                    <div class="svc-sub">{{ item.time }}</div>
                    </div>
                </div>

                <div id="estimate-details" *ngIf="estimateList.length > 0">
                    <div class="splits">
                    <div class="split"><span>Subtotal:</span><strong id="subtotal">₹0</strong></div>
                    <div class="split green"><span>Discount (5%)</span><strong id="discount">-₹0</strong></div>
                    <div class="split"><span>Tax (18%)</span><strong id="tax">₹0</strong></div>
                    </div>
                    <div class="total">
                    <span>Total:</span><span class="amt" id="total">₹0</span>
                    </div>
                    <div class="gst">You can switch to OES in the breakdown to save more.</div>
                    <button class="btn-save">Save Estimate</button>
                    <button class="btn-pdf"  (click)="downloadPDF()" >Download PDF</button>
                    <button class="btn-pdf"><mat-icon class="material-icons">share</mat-icon> Share</button>
                    <div class="note">
                    This is an estimate. Final invoice may vary after inspection,
                    selected brands, taxes, and regional factors.
                    </div>
                </div>
            </aside> -->

        </div>
    </div>
</div>

 <!-- ==========requesta-a-call-bac-pop-up======= -->
<div class="modal fade" id="requestCallBackModal" tabindex="-1" aria-labelledby="requestCallBackModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg custom-modal" style=" width: 400px;">
    <div class="modal-content" style="border-radius: 8px; padding: 10px; height: fit-content;"> 
        <div class="modal-content-sub" >
        <!-- Header -->
            <div class="d-flex justify-content-between align-items-center mb-3" style=" padding: 10px 20px; margin: 0 !important; background: linear-gradient(to right, #F7FBFF, #FFFFFF); border-radius: 10px;">
                <h3 class="fw-bold m-0" style="font-size: 20px; font-weight: 900 !important; color: #0B2636;">
                <div class="call-icon-and-text">
                    <mat-icon>bookmark_border</mat-icon>
                    <div>Book an Appointment</div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                </h3>
            </div>

            <p class="text-muted mb-4" style=" font-size: 14px !important;color: #57738A !important; padding: 5px 20px; margin: 10px 0px !important; font-weight: 400;">
                Quick and easy appointment booking.
            </p>

            <!-- Form -->
            <form [formGroup]="callbackForm" (ngSubmit)="submitForm()" class="callback-form">

                <div class="form-scroll-area">

                    <!-- Name -->
                    <div class="form-floating mb-3">
                    <input type="text" formControlName="name" class="form-control" id="custName" placeholder="Name">
                    <label for="custName">Name *</label>
                    </div>
                    <div class="text-danger small mb-2"
                        *ngIf="submitted && callbackForm.get('name')?.invalid">
                    Name is required
                    </div>

                    <!-- Mobile -->
                    <div class="form-floating mb-3">
                    <input type="text" formControlName="mobile" class="form-control" id="custMobile" placeholder="Mobile Number" maxlength="10">
                    <label for="custMobile">Mobile Number *</label>
                    </div>
                    <div class="text-danger small mb-2"
                        *ngIf="submitted && callbackForm.get('mobile')?.invalid">
                    <span *ngIf="callbackForm.get('mobile')?.errors?.['required']">Mobile number is required</span>
                    <span *ngIf="callbackForm.get('mobile')?.errors?.['pattern']">Mobile number must be 10 digits</span>
                    </div>

                    <!-- Registration Number -->
                    <div class="form-floating mb-3">
                    <input type="text" formControlName="registrationNumber" (input)="formatRegistrationNumber()" class="form-control" id="regNo" placeholder="KA 03 MX 5059">
                    <label for="regNo">Registration Number *</label>
                    </div>
                    <div class="text-danger small mb-2"
                        *ngIf="submitted && callbackForm.get('registrationNumber')?.invalid">
                    <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['required']">Registration number is required</span>
                    <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['pattern']">Format must be like KA 03 MX 4048</span>
                    </div>

                    <!-- Email -->
                    <div class="form-floating mb-3">
                    <input type="email" formControlName="email" class="form-control" id="custEmail" placeholder="Email">
                    <label for="custEmail">Email (Optional)</label>
                    </div>
                </div>

                <!-- Sticky Button -->
                <div class="form-footer">
                    <button type="submit" class="btn btn-primary w-100 submit-btn">
                    Submit Details
                    </button>
                </div>

            </form>
        </div>

    </div>
  </div>
</div>

  <!-- Success Confirmation Modal -->
  <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="width: 30%;">
      <div class="modal-content text-center">
        <div class="modal-body">
          <p style="margin-bottom: 0;">{{ successMessage }}</p>
          <p style="color: green; font-size: 100px;"><i class="uil uil-check-circle"></i></p>
          <p class="lead mb-6">We will call you shortly</p>
          <button type="button" class="btn btn-secondary rounded-pill btn-login w-100 mb-2" (click)="closeSuccessModal()" style="background: #144579;">OK</button>
        </div>
      </div>
    </div>
  </div>
<app-loading *ngIf="loading"></app-loading>


<div class="toast-container position-fixed bottom-0 end-0 p-3">
  <div id="carToast" class="toast align-items-center text-bg-danger border-0" role="alert">
    <div class="d-flex">
      <div class="toast-body">
        <!-- Message will come dynamically -->
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
    </div>
  </div>
</div>
